<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
    <WdsText size="sm" weight="medium">{{ formattedUnits }}</WdsText>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

const PaymentRequestUnitsColumn = graphql(`
  fragment PaymentRequestUnitsColumn on PaymentRequest {
    id
    rateQuantity
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestUnitsColumn>
}>()

const column = computed(() => useFragment(PaymentRequestUnitsColumn, props.row))

const formattedUnits = computed(() => {
  if (!column.value.rateQuantity) return '-'
  return column.value.rateQuantity.toString()
})
</script>

<style scoped></style>
